import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=32a44c30&"
import script from "./UserSettings.vue?vue&type=script&lang=js&"
export * from "./UserSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports